import React from 'react';

/** @param {{ message: string, variant?: 'default' | 'noResults' }} props */
export default function AdminEmptyState({ message, variant = 'default' }) {
  if (!message) return null;
  const cls =
    variant === 'noResults' ? 'admin-hub-kit-empty admin-hub-kit-empty--no-results' : 'admin-hub-kit-empty';
  return (
    <div className={cls} role="status">
      {message}
    </div>
  );
}
